module.exports = __webpack_public_path__ + "static/simon-6a96a639ac0385896b9ade8bed8d4508.png";